import React from 'react';
import blogTopics from '../data/blogTopics';
import '../Style/BlogHighlights.css';

function BlogHighlights() {
  return (
    <section className="blog-highlights">
      <h2 className="textCenter">-Blog-</h2>
      <div className="blog-highlight-grid">
        {blogTopics.map((item) => (
          <article key={item.title} className="blog-highlight-card">
            <a
              href={item.url}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noreferrer' : undefined}
            >
              <div className="blog-highlight-image-wrap">
                <img
                  className="blog-highlight-image"
                  src={item.image}
                  alt={item.alt}
                />
                <span className="blog-highlight-category">{item.category}</span>
              </div>
              <div className="blog-highlight-body">
                <h3>{item.title}</h3>
                <p>{item.summary}</p>
                <span className="blog-highlight-link">Blog</span>
              </div>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}

export default BlogHighlights;
